$(".burger-menu img").on("click", function (e) {
  e.stopPropagation();
  e.preventDefault();
  $(".mobile-menu").toggleClass("active");
  $("body").toggleClass("overflow");
});

$(".red-accept-btn").on("click", function () {
  $('.cookie-wrap').fadeOut();
  localStorage.setItem('cookie-footer-hidden', true);
});


$(".hero-red-btn, .start-btn").click(function () {
  $("html,body").animate(
    {
      scrollTop: $(".main-form").offset().top
    },
    "slow"
  );
});

$(".scrollJs").click(function () {
  $("html,body").animate(
    {
      scrollTop: $(".how-it-works").offset().top
    },
    "slow"
  );
});

$(function () {
  $('.question-mark').hover(function () {
    $(this).parent().find('.tooltipmark').addClass('active');
  }, function () {
    $('.tooltipmark').removeClass('active');
  })
})

function prettifyNum(number) {
  return number.toLocaleString("en-US");
}

if ($(".dollar-range-slider").length > 0) {
  $(".dollar-range-slider").ionRangeSlider({
    min: 0,
    max: 1000,
    from: 0,
    step: 1,
    prefix: "$",
    prettify: prettifyNum,
    to: 500,
    grid: false,
    onChange: function (data) {
      var element = data.input;
      var value = parseFloat($(element).val()).toLocaleString("en-US");
      $(element).parent().find('.calc-input').val('$ ' + value).attr('data-value', $(element).val());
      calculateSum();
    },
    onFinish: function (data) {
      var element = data.input;
      var value = parseFloat($(element).val()).toLocaleString("en-US");
      $(element).parent().find('.calc-input').val('$ ' + value).attr('data-value', $(element).val());
      $(element).parent().next().removeClass('non-active').find('.card').removeClass('non-active');
      calculateSum();
    }
  });
}

if ($(".js-range-slider").length > 0) {
  $(".js-range-slider").ionRangeSlider({
    min: 0,
    max: 1000,
    from: 0,
    step: 1,
    to: 500,
    grid: false,
    onChange: function (data) {
      var element = data.input;
      var value = $(element).val()
      $(element).parent().find('.calc-input').val(value);
      calculateSum();
    },
    onFinish: function (data) {
      var element = data.input;
      var value = $(element).val()
      $(element).parent().find('.calc-input').val(value);
      $(element).parent().next().removeClass('non-active').find('.card').removeClass('non-active');
      calculateSum();
    }
  });
}

$(".select-calc").on("click", function () {
  $(".opened").toggleClass("active");
  $(".select-calc").toggleClass("border-none");
});

function calculateSum() {
  var isFiledValid = true;
  $('.calc-input').each(function () {
    if ($(this).val().trim().length == 0) {
      isFiledValid = false;
    }
  })
  if (isFiledValid) {
    var sumVal = 0;
    $('.calc-input').each(function () {
      sumVal += parseFloat($(this).val());
      let input3 = parseFloat($('.input3').attr('data-value'));
      let input2 = $('.input2').val();
      let input1 = $('.input1').val();
      let sumInp = (parseInt(input1) * parseInt(input2) * parseInt(input3)) * 0.4 / 100000;
      // console.log(sumInp);
      $('.jsInputCost').text(sumInp.toFixed(0) + " X");
      let input4 = $('.input4').val();
      let sumMonth = input4 * sumInp * 0.1;
      // console.log(sumMonth);
      $('.jsInputMonth').text(sumMonth.toFixed(0) + " X");
      let sumRoi = sumInp + sumMonth;
      $('.jsInputSum').html(sumRoi.toFixed(0) + " X");
    })
    // sumVal = sumVal;
    // $('.jsInputSum').html(sumVal);

  }
}


// $('.calc-input').keypress(function (e) {
//   e.preventDefault();
// });


$(document).on("click", '.jsSubmitModalIndex', function (e) {
  e.preventDefault();
  var _this = this;
  $.ajax({
    url: 'sender.php',
    type: 'POST',
    data: {
      name: $(this).parent().find('.jsNameInput').val(),
      email: $(this).parent().find('.jsEmailInput').val(),
      phone: $(this).parent().find('.jsPhoneInput').val(),
      purpose: $(_this).attr('data-modal-type')
    },
    success: function (msg) {
      var modalId = $(_this).attr('data-modal-id');
      $(modalId).modal('show');
      $(_this).parent().find('.jsNameInput').val('');
      $(_this).parent().find('.jsEmailInput').val('');
      $(_this).parent().find('.jsPhoneInput').val('');
    }
  });
});


$(document).on("click", '.jsSubmitCalculatorBtn', function (e) {
  e.preventDefault();
  if ($('.jsCalculatorInputName').val().trim().length > 0 && $('.jsCalculatorInputEmail').val().trim().length > 0) {
    $.ajax({
      url: 'calculator_sender.php',
      type: 'POST',
      data: {
        name: $('.jsCalculatorInputName').val(),
        email: $('.jsCalculatorInputEmail').val(),
        phone: $('.jsCalculatorInputPhone').val(),
        number_lab: $('.jsNumberOfLab').val(),
        number_brand: $('.jsNumberOfBrand').val(),
        avarage_cost: $('.jsAvarageCost').val(),
        avarage_number: $('.jsAvarageNumber').val(),
        calculated_num: parseFloat($('.jsCalculatorInputSum').html()),
        calculated_month: parseFloat($('.jsCalculatorInputMonth').html()),
        calculated_cost: parseFloat($('.jsCalculatorInputCost').html()),
      },
      success: function (response) {
        $('.jsCalculatorInputName').val('');
        $('.jsCalculatorInputEmail').val('');
        $('.jsCalculatorInputPhone').val('');
        $('#calculatorSuccessModal').modal('show');
      }
    });
  }
});


function checkCookieFooter() {
  var val = localStorage.getItem('cookie-footer-hidden');
  if (val != 'true') {
    $('.cookie-wrap').addClass('active');
  } else {
    $('.cookie-wrap').removeClass('active');
  }
}

$(document).ready(function () {
  var notAllowedEmails = ['gmail.com', 'ukr.net', 'mail.ru', 'yahoo.com', 'hotmail.com', 'bing.com', 'yandex.ru']
  function validateEmail(email) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    if (!emailReg.test(email)) {
      return false;
    } else {
      var emailDomain = email.split('@')[1];
      for (var i in notAllowedEmails) {
        if (emailDomain.indexOf(notAllowedEmails[i]) > -1) {
          return false;
        }
      }
      return true;
    }
  }
  function formValidation(formId) {
    var isFormValid = true;
    $('.validateForm.' + formId).find('.jsFormValidationInput').each(function () {
      if ($(this).val().trim().length == 0) {
        isFormValid = false;
        $(this).closest('.inp-wrap').addClass('invalid');
      } else {
        $(this).closest('.inp-wrap').removeClass('invalid');
        if ($(this).attr('type') == 'email') {
          if (!validateEmail($(this).val().trim())) {
            isFormValid = false;
            $(this).closest('.inp-wrap').addClass('invalid');
          }
        }
      }
    })

    if (isFormValid) {
      $('.validateForm.' + formId).find('.jsFormValidationSubmitBtn').removeClass('disable-btn').prop('disabled', false);
    } else {
      $('.validateForm.' + formId).find('.jsFormValidationSubmitBtn').addClass('disable-btn').prop('disabled', true);
    }
  }
  // formValidation();

  $(document).on('input', '.jsFormValidationInput', function () {
    var formId = $(this).closest('.validateForm').attr('data-form-id');
    formValidation(formId)
  });

  checkCookieFooter();
});